export class AppsToBeUsed {
    public Invoice:boolean;
    public Archive:boolean;
    public Despatch:boolean;
    public SMM:boolean;
    public MM:boolean;
    public EDefter:boolean;
    public EMutabakat:boolean;
    
    constructor(){
        this.Invoice = false;
        this.Archive = false;
        this.Despatch = false;
        this.SMM = false;
        this.MM = false;
        this.EDefter = false;
        this.EMutabakat = false;
    }

}
